/* Same-page optional pouch, scoped to the existing stand form. */
if (!customElements.get('foldnix-pouch-addon')) {
  customElements.define('foldnix-pouch-addon', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !window.FoldnixAddonCore) return;
      this.controller = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-addon-config]').textContent);
      this.form = this.closest('form');
      this.checkbox = this.querySelector('[data-addon-toggle]');
      this.selector = this.querySelector('[data-addon-color]');
      this.details = this.querySelector('[data-addon-details]');
      this.message = this.querySelector('[data-addon-message]');
      this.cartLink = this.querySelector('[data-addon-cart-link]');
      this.busy = false;
      const options = { signal: this.controller.signal };
      this.addEventListener('change', () => this.update(), options);
      document.addEventListener('input', event => {
        if (event.target.name === 'quantity' && event.target.form === this.form) this.update();
      }, options);
      document.addEventListener('change', event => {
        if (event.target.name === 'quantity' && event.target.form === this.form) this.update();
      }, options);
      this.form.addEventListener('submit', event => this.submit(event), { ...options, capture: true });
      this.querySelector('[data-addon-controls]').hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    selected() { return this.config.variants.find(v => String(v.id) === this.selector.value); }
    count() { return new FormData(this.form).get('quantity') || 1; }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.config.currency
      }).format(cents / 100);
    }
    update() {
      this.details.hidden = !this.checkbox.checked;
      const chosen = this.selected();
      if (!chosen) return;
      const photo = this.querySelector('[data-addon-image]');
      if (chosen.image) { photo.src = chosen.image; photo.alt = chosen.alt; }
      this.querySelector('[data-addon-price]').textContent = this.money(chosen.price);
      const total = this.querySelector('[data-addon-total]');
      try {
        const value = window.FoldnixAddonCore.selectionTotal(
          this.config.standPrice, this.count(), chosen.price, this.checkbox.checked,
          this.config.offerVerified, this.config.currency
        );
        total.textContent = this.money(value);
      } catch (_) { total.textContent = '—'; }
    }
    setBusy(value) {
      this.busy = value;
      this.setAttribute('aria-busy', String(value));
      this.checkbox.disabled = value;
      this.selector.disabled = value;
      const submits = [...this.form.elements].filter(e => e.type === 'submit');
      if (value) {
        this.savedButtons = submits.map(button => ({ button, disabled: button.disabled }));
        submits.forEach(button => { button.disabled = true; });
      } else this.savedButtons?.forEach(({ button, disabled }) => { button.disabled = disabled; });
    }
    async submit(event) {
      if (!this.checkbox.checked) return; // Original Dawn path remains intact.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.message.textContent = '';
      this.cartLink.hidden = true;
      const selected = this.selected();
      let items;
      try {
        if (!selected?.available) throw new Error('Unavailable pouch');
        const data = new FormData(this.form);
        if (data.get('selling_plan')) throw new Error('Unsupported selling plan');
        items = window.FoldnixAddonCore.buildItems(data.get('id'), this.count(), selected.id,
          this.config.variants.filter(v => v.available).map(v => v.id));
        const properties = {};
        for (const [key, value] of data.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) items[0].properties = properties;
      } catch (_) {
        this.message.textContent = this.config.invalid;
        return;
      }
      this.setBusy(true);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Cart add failed');
        // No automatic retry: a lost response may still mean the cart was updated.
        window.location.assign(window.Shopify.routes.root + 'cart');
      } catch (_) {
        this.message.textContent = this.config.error;
        this.cartLink.hidden = false;
        this.setBusy(false);
      }
    }
  });
}
